// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import _ from "lodash";
import * as Sentry from "@sentry/vue";

Vue.prototype._ = _;

const controller = new AbortController();
Vue.prototype.$abortController = controller;
// 用于参数序列化
import qs from "qs";
Vue.prototype.$qs = qs;
// import '@/assets/js/flexible'
// body样式通用引入失效
import "./assets/css/reset.scss";

// import "./assets/css/font.css";

// es6 ==>>es5兼容ie
import "babel-polyfill";
import promise from "es6-promise";
promise.polyfill();

import vueSwiper from "vue-awesome-swiper";
// import 'swiper/dist/css/swiper.css'

import ECharts from "vue-echarts"; // refers to components/ECharts.vue in webpack
// import ECharts modules manually to reduce bundle size
import echarts from "echarts"; //引入echarts
Vue.prototype.$echarts = echarts; //引入组件

// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'
// If you want to use ECharts extensions, just import the extension package and it will work
// Taking ECharts-GL as an example:
// You only need to install the package with `npm install --save echarts-gl` and import it as follows
// register component to use
// import '@/icons' // icon
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import Share from "vue-social-share";
import QRCode from "qrcodejs2";
Vue.use(Share);

Vue.component("v-chart", ECharts);

// 通用组件配置
import tempConfig from "@/core/tempConfig/tempConfig";
Vue.use(tempConfig);
//引入iview
import iView, { Col, Row } from "view-design";
import "view-design/dist/styles/iview.css";
Vue.use(iView);
Vue.prototype.$Message.config({
  top: 400,
  duration: 2
});

import { Tooltip } from "view-design";

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
// 创建一个标题的渲染函数，用于替换原有的插槽渲染
VXETable.renderer.add("titleLink", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    // let { row, column } = params
    let { events } = renderOpts;
    // console.log(events);
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <a onClick={() => events.click(params.row)}>{params.row.title}</a>
    ];
  }
});
VXETable.renderer.add("orderNumWidthColor", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    // let { row, column } = params
    let { events } = renderOpts;
    // console.log(events);
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <a onClick={() => events.click(params.row)}>{params.row.orderNum}</a>
    ];
  }
});
// 稿件编号后显示自然来稿或基金图标 新增补充附件图标
VXETable.renderer.add("articleNoWithIcon", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;
    const menuList = JSON.parse(sessionStorage.getItem("menuList"));
    var twoList = [];
    var operList = [];
    for (var i in menuList) {
      if (menuList[i].menuName.replace(/\s/g, "") == "作者消息") {
        twoList = menuList[i].twoList;
        break;
      }
    }
    if (twoList.length > 0) {
      operList = twoList.map(item => item.menuName);
    }
    // v3.0.2 处理加急图标 Tooltip 回显订单信息
    // console.log("加急订单信息", row.schedulingOrderList)
    let schedulingOrderElem =
      row.schedulingOrderList && row.schedulingOrderList.length ? (
        <Tooltip placement="top" max-width="400" transfer>
          <div slot="content">
            {row.schedulingOrderList.map((orderInfo, index) => {
              return (
                <Row style="min-width:200px; text-align:center" align="middle">
                  <Col span="8">
                    <span>{orderInfo.periodicalFeeName || "加急费"}</span>
                  </Col>
                  <Col span="8">
                    {/* 订单金额 */}
                    <span>{orderInfo.payAmount}</span>
                  </Col>
                  <Col span="8">
                    {" "}
                    {/* 支付状态 payStatus 0未支付/待退款，1已支付，2已取消，3已关闭，4已退款，5审核中, 6回单审核中
 1， 5，6 已支付  0 未支付 3 已停用 */}
                    <span>
                      {orderInfo.payStatus == 0
                        ? "未支付"
                        : orderInfo.payStatus == 3
                        ? "已停用"
                        : orderInfo.payStatus == 1 ||
                          orderInfo.payStatus == 5 ||
                          orderInfo.payStatus == 6
                        ? "已支付"
                        : ""}
                    </span>
                  </Col>
                </Row>
              );
            })}
          </div>
          {row.schedulingType == "1" ? (
            <img src={require("@/assets/images/urgent.png")}></img>
          ) : row.schedulingType == "2" ? (
            <img src={require("@/assets/images/jiaji.png")}></img>
          ) : row.schedulingType == "3" ? (
            <img src={require("@/assets/images/jiaji_half.png")}></img>
          ) : null}
        </Tooltip>
      ) : null;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="found">
        <p>{row.articleNo || row.artNo}</p>
        <div class="articleNo-icons">
          {row.foundationFlag == 1 && row.foundationStatus == 1 ? (
            <img
              onClick={() => events.click(row.id || row.artId)}
              src={require("./assets/images/foundYes.png")}
              title="基金"
            ></img>
          ) : null}
          {row.foundationFlag == 1 && row.foundationStatus == 0 ? (
            <img
              onClick={() => events.click(row.id || row.artId)}
              src={require("./assets/images/foundNo.png")}
              title="基金"
            ></img>
          ) : null}
          {row.natureArticleType === "0" ? (
            <img
              src={require("./assets/images/ziranlaigao.png")}
              class="zrlg"
            ></img>
          ) : null}
          {/* 3.0.1 加急 */}
          {schedulingOrderElem ? (
            schedulingOrderElem
          ) : row.schedulingType == "1" ? (
            <img src={require("@/assets/images/urgent.png")}></img>
          ) : row.schedulingType == "2" ? (
            <img src={require("@/assets/images/jiaji.png")}></img>
          ) : row.schedulingType == "3" ? (
            <img src={require("@/assets/images/jiaji_half.png")}></img>
          ) : null}

          {/* 补充附件图标
          annexStatus状态：0代表期刊未开启补充附件或者稿件未申请补充附件；1表示稿件申请了补充附件，且状态中含有未补充的；2表示稿件的补充附件已经补充完毕*/}
          {row.annexStatus == "1" ? (
            <img src={require("@/assets/images/unSupplementAnnex.png")}></img>
          ) : null}
          {row.annexStatus == "2" ? (
            <img src={require("@/assets/images/supplementAnnex.png")}></img>
          ) : null}
          {row.supplementStatus == "1" ? (
            <img src={require("@/assets/images/unSupplementAnnex.png")}></img>
          ) : null}
          {row.supplementStatus == "2" ? (
            <img src={require("@/assets/images/supplementAnnex.png")}></img>
          ) : null}
          {row.ignoreStatus == "1" ? (
            <img
              title={row.auditUser}
              src={require("@/assets/images/hulue.png")}
            ></img>
          ) : null}
          {row.orderStatus == "3" ? (
            <img
              title={row.ingoreName}
              src={require("@/assets/images/hulue.png")}
            ></img>
          ) : null}
          {row.employmentAmount > 0 ? (
            <img src={require("@/assets/images/append.png")}></img>
          ) : null}
          {/* 外审审核进度 auditScheduleStatus，无外审，1待审核，2部分审核，3全部审核
          待外审灰色，全部完成外审为蓝色，完成部分外审为绿色标  */}
          {row.auditScheduleStatus && row.auditScheduleStatus == "1" ? (
            <Tooltip content="待外审" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_gray.png")}></img>
            </Tooltip>
          ) : row.auditScheduleStatus && row.auditScheduleStatus == "2" ? (
            <Tooltip content="外审部分完成" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_half.png")}></img>
            </Tooltip>
          ) : row.auditScheduleStatus && row.auditScheduleStatus == "3" ? (
            <Tooltip content="外审完成" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_blue.png")}></img>
            </Tooltip>
          ) : null}

          {/* 3.0.3 退修标 及退修次数*/}
          {row.revisionNum ? (
            <span class="tuixiu-icon">
              <span>
                {" "}
                <img src={require("@/assets/images/tuixiu.png")}></img>
              </span>
              <span class="tuixiu-num">
                {row.revisionNum}
                {/* <span class="tuixiu-num">{row.revisionNum}</span> */}
              </span>
            </span>
          ) : null}
          {row.auditSign == "" ? (
            ""
          ) : row.auditSign == "0" ? (
            <img src={require("./assets/images/shGray.png")}></img>
          ) : row.auditSign == "1" ? (
            <img src={require("./assets/images/shBlue.png")}></img>
          ) : (
            ""
          )}

          {row.otherStatus == "1" ? (
            <img src={require("./assets/images/buGray.png")}></img>
          ) : row.otherStatus == "2" ? (
            <img src={require("./assets/images/buRed.png")}></img>
          ) : (
            ""
          )}

          <span onClick={() => events.click(row.dto ? row.dto : "", "meeting")}>
            {row.dto && row.dto.meetingSign == 1 ? (
              <img src={require("./assets/images/hyGray.png")}></img>
            ) : row.dto && row.dto.meetingSign == 2 ? (
              <img src={require("./assets/images/hyGreen.png")}></img>
            ) : row.dto && row.dto.meetingSign == 3 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : row.dto && row.dto.meetingSign == 4 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : (
              ""
            )}
          </span>

          {operList.includes("审核节点查看消息") ? (
            <span onClick={() => events.click(row ? row : "", "chatModel")}>
              {row.chatStatus == 1 ? (
                <img src={require("./assets/images/lyRed.png")}></img>
              ) : row.chatStatus == 2 ? (
                <img src={require("./assets/images/lyBlue.png")}></img>
              ) : (
                ""
              )}
            </span>
          ) : (
            ""
          )}
        </div>
        {/* </div> */}
      </div>
    ];
  }
});
// 稿件编号后显示自然来稿或基金图标 新增补充附件图标
VXETable.renderer.add("articleNoWithIconArt", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;
    // v3.0.2 处理加急图标 Tooltip 回显订单信息
    // console.log("加急订单信息", row.schedulingOrderList)
    let schedulingOrderElem =
      row.schedulingOrderList && row.schedulingOrderList.length ? (
        <Tooltip placement="top" max-width="400" transfer>
          <div slot="content">
            {row.schedulingOrderList.map((orderInfo, index) => {
              return (
                <Row style="min-width:200px; text-align:center" align="middle">
                  <Col span="8">
                    <span>{orderInfo.periodicalFeeName || "加急费"}</span>
                  </Col>
                  <Col span="8">
                    {/* 订单金额 */}
                    <span>{orderInfo.payAmount}</span>
                  </Col>
                  <Col span="8">
                    {" "}
                    {/* 支付状态 payStatus 0未支付/待退款，1已支付，2已取消，3已关闭，4已退款，5审核中, 6回单审核中
 1， 5，6 已支付  0 未支付 3 已停用 */}
                    <span>
                      {orderInfo.payStatus == 0
                        ? "未支付"
                        : orderInfo.payStatus == 3
                        ? "已停用"
                        : orderInfo.payStatus == 1 ||
                          orderInfo.payStatus == 5 ||
                          orderInfo.payStatus == 6
                        ? "已支付"
                        : ""}
                    </span>
                  </Col>
                </Row>
              );
            })}
          </div>
          {row.schedulingType == "1" ? (
            <img src={require("@/assets/images/urgent.png")}></img>
          ) : row.schedulingType == "2" ? (
            <img src={require("@/assets/images/jiaji.png")}></img>
          ) : row.schedulingType == "3" ? (
            <img src={require("@/assets/images/jiaji_half.png")}></img>
          ) : null}
        </Tooltip>
      ) : null;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="found">
        <p>{row.articleNo || row.artNo}</p>
        <div class="articleNo-icons">
          {row.foundationFlag == 1 && row.foundationStatus == 1 ? (
            <img
              onClick={() => events.click(row.articleId || row.artId)}
              src={require("./assets/images/foundYes.png")}
              title="基金"
            ></img>
          ) : null}
          {row.foundationFlag == 1 && row.foundationStatus == 0 ? (
            <img
              onClick={() => events.click(row.articleId || row.artId)}
              src={require("./assets/images/foundNo.png")}
              title="基金"
            ></img>
          ) : null}
          {row.natureArticleType === "0" ? (
            <img
              src={require("./assets/images/ziranlaigao.png")}
              class="zrlg"
            ></img>
          ) : null}
          {/* 3.0.1 加急 */}
          {schedulingOrderElem ? (
            schedulingOrderElem
          ) : row.schedulingType == "1" ? (
            <img src={require("@/assets/images/urgent.png")}></img>
          ) : row.schedulingType == "2" ? (
            <img src={require("@/assets/images/jiaji.png")}></img>
          ) : row.schedulingType == "3" ? (
            <img src={require("@/assets/images/jiaji_half.png")}></img>
          ) : null}

          {/* 补充附件图标
          annexStatus状态：0代表期刊未开启补充附件或者稿件未申请补充附件；1表示稿件申请了补充附件，且状态中含有未补充的；2表示稿件的补充附件已经补充完毕*/}
          {row.annexStatus == "1" ? (
            <img src={require("@/assets/images/unSupplementAnnex.png")}></img>
          ) : null}
          {row.annexStatus == "2" ? (
            <img src={require("@/assets/images/supplementAnnex.png")}></img>
          ) : null}
          {row.employmentAmount > 0 ? (
            <img src={require("@/assets/images/append.png")}></img>
          ) : null}
          {/* 外审审核进度 auditScheduleStatus，无外审，1待审核，2部分审核，3全部审核
          待外审灰色，全部完成外审为蓝色，完成部分外审为绿色标  */}
          {row.auditScheduleStatus && row.auditScheduleStatus == "1" ? (
            <Tooltip content="待外审" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_gray.png")}></img>
            </Tooltip>
          ) : row.auditScheduleStatus && row.auditScheduleStatus == "2" ? (
            <Tooltip content="外审部分完成" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_half.png")}></img>
            </Tooltip>
          ) : row.auditScheduleStatus && row.auditScheduleStatus == "3" ? (
            <Tooltip content="外审完成" placement="top" transfer>
              {" "}
              <img src={require("@/assets/images/waishen_blue.png")}></img>
            </Tooltip>
          ) : null}

          {/* 3.0.3 退修标 及退修次数*/}
          {row.revisionNum ? (
            <span class="tuixiu-icon">
              <span>
                {" "}
                <img src={require("@/assets/images/tuixiu.png")}></img>
              </span>
              <span class="tuixiu-num">
                {row.revisionNum}
                {/* <span class="tuixiu-num">{row.revisionNum}</span> */}
              </span>
            </span>
          ) : null}
          {row.auditSign == "" ? (
            ""
          ) : row.auditSign == "0" ? (
            <img src={require("./assets/images/shGray.png")}></img>
          ) : row.auditSign == "1" ? (
            <img src={require("./assets/images/shBlue.png")}></img>
          ) : (
            ""
          )}
        </div>
        {/* </div> */}
      </div>
    ];
  }
});
// 追加金额
VXETable.renderer.add("appendPrice", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="found">
        <p>
          {row.employmentAmount > 0
            ? row.orderAmount + "(含+" + row.employmentAmount + ")"
            : row.orderAmount}
        </p>
      </div>
    ];
  }
});
// 追加免费图标
VXETable.renderer.add("discountType", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="found">
        <p>
          {row.discountTypeName}
          {row.discountTypeName && row.discountAmount == row.payAmount ? (
            <img src={require("@/assets/images/mianfei.png")}></img>
          ) : null}
        </p>
      </div>
    ];
  }
});
// 查重
VXETable.renderer.add("checkStatusTag", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="checkStatusTag">
        <p>
          {row.checkStatusVal}
          {row.checkStatus == "3" ? (
            <Tooltip
              content={row.errorMsg}
              placement="top"
              transfer
              transfer-class-name="my-table-tip"
            >
              {" "}
              <img
                src={require("@/assets/images/jingshi.png")}
                style="margin-left: 5px;"
              ></img>
            </Tooltip>
          ) : null}
        </p>
      </div>
    ];
  }
});
// 追加图标
VXETable.renderer.add("appendIcon", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;

    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="found">
        <p>
          {row.orderTypeName}
          {row.employmentAmount > 0 ? (
            <img src={require("@/assets/images/append.png")}></img>
          ) : null}
        </p>
      </div>
    ];
  }
});
//状态图标
VXETable.renderer.add("statusName", {
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    let { events } = renderOpts;
    return [
      <div class="found">
        <p>{row.payStatusName}</p>

        <div class="articleNo-icons">
          {row.payAmount == "0.00元" && row.payStatusName == "已支付" ? (
            <img src={require("./assets/images/mianfei.png")}></img>
          ) : null}
        </div>
      </div>
    ];
  }
});
//基金审核图标
VXETable.renderer.add("articleJj", {
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    let { events } = renderOpts;
    return [
      <div class="found">
        <p>{row.articleNo || row.artNo}</p>

        <div class="articleNo-icons">
          {row.foundationFlag == 1 && row.foundationStatus == 1 ? (
            <img
              onClick={() => events.click(row.articleId)}
              src={require("./assets/images/foundYes.png")}
              title="基金"
            ></img>
          ) : null}
          {row.foundationFlag == 1 && row.foundationStatus == 0 ? (
            <img
              onClick={() => events.click(row.articleId)}
              src={require("./assets/images/foundNo.png")}
              title="基金"
            ></img>
          ) : null}
          <span onClick={() => events.click(row.dto ? row.dto : "", "meeting")}>
            {row.dto && row.dto.meetingSign == 1 ? (
              <img src={require("./assets/images/hyGray.png")}></img>
            ) : row.dto && row.dto.meetingSign == 2 ? (
              <img src={require("./assets/images/hyGreen.png")}></img>
            ) : row.dto && row.dto.meetingSign == 3 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : row.dto && row.dto.meetingSign == 4 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : (
              ""
            )}
          </span>
        </div>
      </div>
    ];
  }
});
//会议详情标
VXETable.renderer.add("articleMeeting", {
  renderDefault(h, renderOpts, params) {
    let { row, column } = params;
    let { events } = renderOpts;
    return [
      <div class="found">
        <p>{row.articleNo || row.artNo}</p>

        <div class="articleNo-icons">
          <span onClick={() => events.click(row.dto ? row.dto : "", "meeting")}>
            {row.dto && row.dto.meetingSign == 1 ? (
              <img src={require("./assets/images/hyGray.png")}></img>
            ) : row.dto && row.dto.meetingSign == 2 ? (
              <img src={require("./assets/images/hyGreen.png")}></img>
            ) : row.dto && row.dto.meetingSign == 3 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : row.dto && row.dto.meetingSign == 4 ? (
              <img src={require("./assets/images/hyRed.png")}></img>
            ) : (
              ""
            )}
          </span>
        </div>
      </div>
    ];
  }
});
// 订单编号单元格渲染
VXETable.renderer.add("orderNumWidthStatusIcon", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;
    let textColor =
      row.payStatus == 5 ? "color:red;cursor: pointer;" : "cursor: pointer;";
    let imgStyle = "width: 20px;height: 20px;vertical-align: middle;";
    let imgStyle1 = "width: 16px;height: 16px;";
    return [
      // {row.payStatus == 5?(
      <div style={textColor}>
        {row.discountsStatus == 0 ||
        row.discountsStatus == 3 ||
        row.discountsStatus == "" ? (
          <p onClick={() => events.click(row)}>{row.orderNum}</p>
        ) : null}

        {row.discountsStatus == 1 ? (
          <p onClick={() => events.click(row)}>
            {row.orderNum}&nbsp;&nbsp;&nbsp;
            <img
              title="审核中"
              src={require("./assets/images/info.png")}
              style={imgStyle}
            />
          </p>
        ) : null}
        {row.discountsStatus == 2 ? (
          <p onClick={() => events.click(row)}>
            {row.orderNum}&nbsp;&nbsp;&nbsp;
            <img
              title="审核通过"
              src={require("./assets/images/green.png")}
              style={imgStyle}
            />
          </p>
        ) : null}
        {row.abnormalFlag == "" ||
        row.abnormalFlag == 1 ||
        row.abnormalFlag == 2 ? (
          <p onClick={() => events.click(row)}>
            {row.orderNum}&nbsp;&nbsp;&nbsp;
            {row.abnormalFlag == 2 ? (
              <img
                title="异常"
                src={require("./assets/images/warning.png")}
                style={imgStyle1}
              />
            ) : null}
          </p>
        ) : null}
      </div>
      // ):null}
    ];
  }
});
// 追加图标
VXETable.renderer.add("blackIcon", {
  // 默认显示模板
  renderDefault(h, renderOpts, params) {
    // params中包含了当前单元格所在的行和列
    let { row, column } = params;
    let { events } = renderOpts;
    let imgStyle = "vertical-align: middle;";
    // 返回JSX语法格式的HTML模板
    return [
      // events为单元格渲染时的配置对象，如events:{click:articleDetail}
      // events.click用于获取单元格绑定的事件函数
      <div class="blackIcon">
        <p>
          {row.name}&nbsp;&nbsp;&nbsp;
          {row.blacklistType == 1 ? (
            <img
              src={require("@/assets/images/blackIcon.png")}
              style={imgStyle}
            ></img>
          ) : null}
        </p>
      </div>
    ];
  }
});

Vue.use(VXETable);

if (!("classList" in document.documentElement)) {
  //ie9 table组件报错
  Object.defineProperty(HTMLElement.prototype, "classList", {
    get: function() {
      var self = this;
      function update(fn) {
        return function(value) {
          var classes = self.className.split(/\s+/g),
            index = classes.indexOf(value);

          fn(classes, index, value);
          self.className = classes.join(" ");
          //console.log(self.className)
        };
      }
      return {
        remove: update(function(classes, index) {
          if (~index) classes.splice(index, 1);
        })
      };
    }
  });
}
if (window.HTMLElement) {
  //ie9 select
  if (
    Object.getOwnPropertyNames(HTMLElement.prototype).indexOf("dataset") === -1
  ) {
    Object.defineProperty(HTMLElement.prototype, "dataset", {
      get: function() {
        var attributes = this.attributes; // 获取节点的所有属性
        var name = [];
        var value = []; // 定义两个数组保存属性名和属性值
        var obj = {}; // 定义一个空对象
        for (var i = 0; i < attributes.length; i++) {
          // 遍历节点的所有属性
          if (attributes[i].nodeName.slice(0, 5) === "data-") {
            // 如果属性名的前面5个字符符合"data-"
            // 取出属性名的"data-"的后面的字符串放入name数组中
            name.push(attributes[i].nodeName.slice(5));
            // 取出对应的属性值放入value数组中
            value.push(attributes[i].nodeValue);
          }
        }
        for (var j = 0; j < name.length; j++) {
          // 遍历name和value数组
          obj[name[j]] = value[j]; // 将属性名和属性值保存到obj中
        }
        return obj; // 返回对象
      }
    });
  }
}

// 动态设置title
Vue.use(require("vue-wechat-title"));

// 暴露全局请求方法
import api from "./core/api/config/index";
Vue.use(api);
//注册全局通用属性,方法
import global from "@/core/global/global";
Vue.use(global);

// 原生交互方法
import native from "@/core/native/index";
Vue.use(native);

// 通用指令
import directive from "@/core/directive/directive";
Vue.use(directive);

// 筛选
import filters from "@/core/filters/filters";
Vue.use(filters);

//动态获取title
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
//cookie插件
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

Vue.config.productionTip = false;
import store from "@/core/store/index";
// import {mapState,mapMutations,mapGetters,mapActions} from "vuex"
/* eslint-disable no-new */

//分享
import share from "vue-social-share";
Vue.use(share);

//复制
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

Sentry.init({
  Vue,
  dsn:
    "https://a4cd238aef58946a690f700b7569c3a7@o4511934847778816.ingest.us.sentry.io/4511934872223744",
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  }
});

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js